var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 24",
    width: 23,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M4.312 0C2.723 0 1.44 1.283 1.44 2.872V20.128c0 1.589 1.283 2.872 2.872 2.872H17.248c1.589 0 2.872-1.283 2.872-2.872V2.872C20.12 1.283 18.837 0 17.248 0H4.312zM9.343 13.5h2.874c1.983 0 3.588 1.605 3.588 3.588 0 .394-.322.715-.715.715H6.471c-.394 0-.715-.322-.715-.715 0-1.983 1.605-3.588 3.588-3.588zm-1.437-4.313a3.588 3.588 0 1 1 7.176 0 3.588 3.588 0 1 1 -7.176 0zM23 3.588c0-.394-.322-.715-.715-.715s-.715.322-.715.715v2.874c0 .394.322.715.715.715s.715-.322.715-.715V3.588zM22.22 8.61c-.394 0-.715.322-.715.715v2.874c0 .394.322.715.715.715s.715-.322.715-.715V9.325c0-.394-.322-.715-.715-.715zm.715 7.176c0-.394-.322-.715-.715-.715s-.715.322-.715.715v2.874c0 .394.322.715.715.715s.715-.322.715-.715V15.785z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.04889f4205cc0bfa5f2f4516fdc951dd.svg";
export { ForwardRef as ReactComponent };